import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    tags: [],
    tagCourses: [],
    formTag: [
      {
        type: 'input',
        name: 'tag',
        label: 'نام تگ به فارسی',
        msg: 'فیلد نباید خالی باشد',
        model: '',
        star: true,
        col: '4',
        rule: 'required'

      },
      {
        type: 'input',
        name: 'en_tag',
        label: 'نام تگ به انگلیسی',
        msg: 'فیلد نباید خالی باشد',
        model: '',
        star: true,
        col: '4',
        rule: 'required'
      }
    ]
  }),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/tag/index.js